import {Hook} from "./Hook.js";

export class Application {

    booting = new Hook();
    booted = new Hook();

    /**
     * @type {Map<function,{singleton:boolean,resolver:function,instance:Object|null}>}
     * @private
     */
    _bindings = new Map();

    /**
     * @type {boolean}
     * @private
     */
    _isBooted = false;

    /**
     * @param {string|function} abstract
     * @param {function} resolver
     */
    bind(abstract, resolver) {
        if (this._resolverIsClass(resolver)) {
            this._bindings.set(abstract, {singleton:false, resolver: () => new resolver, instance: null});
            return;
        }
        this._bindings.set(abstract, {singleton:false, resolver: resolver, instance: null});
    }

    /**
     * @param {string|function} abstract
     * @param {function} resolver
     */
    bindSingleton(abstract, resolver) {
        this._bindings.set(abstract, {singleton:true, resolver: resolver, instance: null});
    }

    /**
     * @template T
     * @param {function(new:T)} abstract
     * @return {T}
     */
    resolve(abstract) {
        if (!this._bindings.has(abstract)) {
            if (typeof abstract !== 'function') {
                throw new Error('Binding "' + abstract + '" not found');
            }
            return new abstract();
        }
        const binding = this._bindings.get(abstract);
        if (!binding.singleton) {
            return binding['resolver']();
        }
        if (!binding.instance) {
            binding.instance = binding.resolver();
        }
        return binding.instance;
    }

    /**
     * The same as resolve() but for string bindings.
     *
     * @param {string} binding
     * @return {Object}
     */
    get(binding) {
        // noinspection JSCheckFunctionSignatures
        return this.resolve(binding);
    }

    /**
     * Return a function to resolve bindings stored in container
     * @return {function}
     */
    resolver() {
        return abstract => this.resolve(abstract);
    }

    async boot() {
        this.booting.fire();
        this._isBooted = true;
        this.booted.fire();
    }

    /**
     * @return {boolean}
     */
    isBooted() {
        return this._isBooted;
    }

    _resolverIsClass(resolver) {
        return resolver.toString().substring(0, 6) === 'class ';
    }
}